import React from "react";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import Footer from "./Components/footer";
import FAQ from "./Components/faq";
import Team from "./Components/team";

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {"Copyright © "}
            <Link color="inherit" href="/">
                VLearnAI
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundImage: "url(/learning.jpg)",
        padding: theme.spacing(15, 0, 8),
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "bottom",
        height: 600,
    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    card: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    cardMedia: {
        paddingTop: "56.25%", // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
}));

export default function Album() {
    const classes = useStyles();

    return (
        <React.Fragment>
            <CssBaseline />
            <main>
                {/* Hero unit */}
                <div className={classes.heroContent}>
                    <Container maxWidth="sm">
                        <Typography
                            component="h1"
                            variant="h2"
                            align="center"
                            style={{ color: "#fff" }}
                            gutterBottom
                        >
                            VLearnAI
                        </Typography>
                        <Typography
                            variant="h5"
                            align="center"
                            style={{ color: "#fff" }}
                            paragraph
                        >
                            A platform for IR4.0 uLesson recommendation.
                        </Typography>
                        <div className={classes.heroButtons}>
                            <Grid container spacing={2} justify="center">
                                <Grid item>
                                    <a
                                        style={{ textDecoration: "none" }}
                                        href="#about-us"
                                    >
                                        <Button
                                            variant="contained"
                                            color="primary"
                                        >
                                            Learn more about us
                                        </Button>
                                    </a>
                                </Grid>
                                <Grid item>
                                    <a
                                        style={{ textDecoration: "none" }}
                                        href="#faq"
                                    >
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                        >
                                            Have question?
                                        </Button>
                                    </a>
                                </Grid>
                            </Grid>
                        </div>
                    </Container>
                </div>
                <Container className={classes.cardGrid} maxWidth="md">
                    <Typography
                        component="h2"
                        variant="h3"
                        align="center"
                        style={{ color: "#000", margin: "8rem 0rem 5rem" }}
                    >
                        Enchance the way we learn
                    </Typography>
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Card className={classes.card}>
                                <CardMedia
                                    className={classes.cardMedia}
                                    image="/variety.jpg"
                                    title="Image title"
                                />
                                <CardContent className={classes.cardContent}>
                                    <Typography
                                        gutterBottom
                                        variant="h5"
                                        component="h2"
                                    >
                                        Wide Selections Available
                                    </Typography>
                                    <Typography align="left">
                                        Numerous online learning tutorial
                                        available from entry-level to expert.
                                    </Typography>
                                </CardContent>
                                <CardActions
                                    style={{
                                        width: "100%",
                                        justifyContent: "flex-end",
                                    }}
                                >
                                    <Button size="small" color="primary">
                                        Learn More
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Card className={classes.card}>
                                <CardMedia
                                    className={classes.cardMedia}
                                    image="/professional.jpg"
                                    title="Image title"
                                />
                                <CardContent className={classes.cardContent}>
                                    <Typography
                                        gutterBottom
                                        variant="h5"
                                        component="h2"
                                    >
                                        Experienced Instructor
                                    </Typography>
                                    <Typography align="left">
                                        All the contents are created by
                                        professional individual or organization
                                        who has experience in relevant fields.
                                    </Typography>
                                </CardContent>
                                <CardActions
                                    style={{
                                        width: "100%",
                                        justifyContent: "flex-end",
                                    }}
                                >
                                    <Button size="small" color="primary">
                                        Learn More
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Card className={classes.card}>
                                <CardMedia
                                    className={classes.cardMedia}
                                    image="/hands-on.jpg"
                                    title="Image title"
                                />
                                <CardContent className={classes.cardContent}>
                                    <Typography
                                        gutterBottom
                                        variant="h5"
                                        component="h2"
                                    >
                                        Hands-on Practice Your Skills
                                    </Typography>
                                    <Typography align="left">
                                        It is not only basic introduction, it
                                        provide real hands-on practice guidance
                                        to student.
                                    </Typography>
                                </CardContent>
                                <CardActions
                                    style={{
                                        width: "100%",
                                        justifyContent: "flex-end",
                                    }}
                                >
                                    <Button size="small" color="primary">
                                        Learn More
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    </Grid>
                </Container>
            </main>
            <div id="about-us">
                <Team />
            </div>
            <div id="faq">
                <FAQ />
            </div>

            <Footer />
        </React.Fragment>
    );
}
